var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12C6 10.5858 6 9.87868 6.43934 9.43934C6.87868 9 7.58579 9 9 9H15C16.4142 9 17.1213 9 17.5607 9.43934C18 9.87868 18 10.5858 18 12V16C18 17.4142 18 18.1213 17.5607 18.5607C17.1213 19 16.4142 19 15 19H9C7.58579 19 6.87868 19 6.43934 18.5607C6 18.1213 6 17.4142 6 16V12Z",
    fill: "black",
    fillOpacity: 0.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_2293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3309 15.8248C13.3309 19.2323 10.5707 22 7.17239 22C3.77411 22 1 19.2323 1 15.8248C1 12.4173 3.76024 9.64954 7.15852 9.64954C10.5568 9.64954 13.317 12.4173 13.317 15.8248H13.3309Z",
    fill: "#2820FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 15.8248C22 19.2323 19.2397 22 15.8415 22C12.4432 22 9.66907 19.2323 9.66907 15.8248C9.66907 12.4173 12.4293 9.64954 15.8415 9.64954C19.2536 9.64954 22 12.4173 22 15.8248Z",
    fill: "#FF5555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.825 8.17524C17.825 11.5828 15.0648 14.3505 11.6665 14.3505C8.26819 14.3505 5.49408 11.5828 5.49408 8.17524C5.49408 4.76773 8.25432 2 11.6526 2C15.0509 2 17.8111 4.76773 17.8111 8.17524H17.825Z",
    fill: "#FFA819"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_2293"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 20,
    fill: "white",
    transform: "translate(1 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFill);
export default __webpack_public_path__ + "static/media/fill.0a1f76d2811fa4381398c023449f8f46.svg";
export { ForwardRef as ReactComponent };